module.exports = __webpack_public_path__ + "img/file-alt.ce7a496c.svg";